import React, { Component } from 'react';
import '../global';
import { connect } from 'react-redux';
import { updateFormErrors } from '../actions';

class CheckoutCardDetails extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			_checkout_card_name            : '',
			_checkout_card_number          : '',
			_checkout_card_expiration_month: '',
			_checkout_card_expiration_year : '',
			_checkout_card_csc             : '',
			_checkout_card_additional_info : ''
		};
		this.handleInputChange = this.handleInputChange.bind( this );
		this.validateCardName = this.validateCardName.bind( this );
		this.validateCardNumber = this.validateCardNumber.bind( this );
		this.validateExpirationMonth = this.validateExpirationMonth.bind( this );
		this.validateExpirationYear = this.validateExpirationYear.bind( this );
		this.validateCVV = this.validateCVV.bind( this );
		this.isCardExpired = this.isCardExpired.bind( this );

	}

	handleInputChange( event ) {
		const { name, value } = event.target;
		this.setState( { [ name ]: value } );
	}

	validateCardName( event ) {
		const { value } = event.target;
		const isValid = /^[a-zA-Z\s]{2,}$/.test( value );

		// Create a new object from the current form errors
		const newFormErrors = { ...this.props.form_errors };

		if ( !isValid ) {
			newFormErrors._checkout_card_name = 'Please enter a valid name (at least 2 characters, letters and spaces only).';
		} else {
			// Remove the field if it exists
			delete newFormErrors._checkout_card_name;
		}

		// Update form errors with the new object
		this.props.updateFormErrors( newFormErrors );
	}

	luhnCheck( cardNumber ) {
		if ( !cardNumber.length ) {
			return false;
		}

		const digits = cardNumber.split( '' ).map( Number );
		const lastDigit = digits.pop();
		digits.reverse();

		let sum = digits.reduce( ( acc, digit, index ) => {
			if ( index % 2 === 0 ) {
				digit *= 2;
				if ( digit > 9 ) {
					digit -= 9;
				}
			}
			return acc + digit;
		}, 0 );

		sum += lastDigit;
		return sum % 10 === 0;
	}

	isCardExpired( month, year ) {
		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11

		if ( year < currentYear ) {
			return true;
		} else if ( year == currentYear && month < currentMonth ) {
			return true;
		}
		return false;
	}

	validateExpirationMonth( event ) {
		const { value } = event.target;
		const year = this.state._checkout_card_expiration_year;

		const newFormErrors = { ...this.props.form_errors };

		if ( !value || value === 'MM' ) {
			newFormErrors._checkout_card_expiration_month = 'Please select a valid expiration month.';
		} else if ( year && this.isCardExpired( parseInt( value ), parseInt( year ) ) ) {
			newFormErrors._checkout_card_expiration = 'The card has expired.';
		} else {
			delete newFormErrors._checkout_card_expiration_month;
			delete newFormErrors._checkout_card_expiration;
		}

		this.props.updateFormErrors( newFormErrors );
	}

	validateExpirationYear( event ) {
		const { value } = event.target;
		const month = this.state._checkout_card_expiration_month;

		const newFormErrors = { ...this.props.form_errors };

		if ( !value || value === 'YYYY' ) {
			newFormErrors._checkout_card_expiration_year = 'Please select a valid expiration year.';
		} else if ( month && this.isCardExpired( parseInt( month ), parseInt( value ) ) ) {
			newFormErrors._checkout_card_expiration = 'The card has expired.';
		} else {
			delete newFormErrors._checkout_card_expiration_year;
			delete newFormErrors._checkout_card_expiration;
		}

		this.props.updateFormErrors( newFormErrors );
	}

	validateCardNumber( event ) {
		const { value } = event.target;
		const cleanedValue = value.replace( /\s+/g, '' );
		const isValid = this.isValidCardNumber( cleanedValue );

		// Create a new object from the current form errors
		const newFormErrors = { ...this.props.form_errors };

		if ( !isValid ) {
			newFormErrors._checkout_card_number = 'Please enter a valid credit card number.';
		} else {
			// Remove the field if it exists
			delete newFormErrors._checkout_card_number;
		}

		// Update form errors with the new object
		this.props.updateFormErrors( newFormErrors );
	}

	validateCVV( event ) {
		const { value } = event.target;

		// Create a new object from the current form errors
		const newFormErrors = { ...this.props.form_errors };

		if ( !value || value.length !== 3 && value.length !== 4 ) {
			newFormErrors._checkout_card_csc = 'Please enter a valid CVV (3 or 4 digits).';
		} else {
			// Remove the field if it exists
			delete newFormErrors._checkout_card_csc;
		}

		// Update form errors with the new object
		this.props.updateFormErrors( newFormErrors );
	}

	isValidCardNumber( cardNumber ) {
		if ( !/^\d+$/.test( cardNumber ) ) {
			return false;
		}

		const cardPatterns = {
			visa       : /^4\d{12}(\d{3})?$/,
			mastercard : /^(5[1-5]\d{14}|2(22[1-9]\d{12}|2[3-9]\d{13}|[3-6]\d{14}|7[0-1]\d{13}|720\d{12}))$/,
			amex       : /^3[47]\d{13}$/,
			discover   : /^(6011\d{12}|65\d{14}|64[4-9]\d{13}|622(12[6-9]|1[3-9]\d|[2-8]\d\d|9[01]\d|92[0-5])\d{10})$/,
			diners_club: /^3(0[0-5]\d{11}|[68]\d{12})$/,
			jcb        : /^(35\d{14}|2131\d{11}|1800\d{11})$/
		};

		return Object.values( cardPatterns )
		             .some( pattern => pattern.test( cardNumber ) );
	}

	render() {
		const {
			      _checkout_card_name,
			      _checkout_card_number,
			      _checkout_card_expiration_month,
			      _checkout_card_expiration_year,
			      _checkout_card_csc,
			      _checkout_card_additional_info
		      } = this.state;
		return (<div className="form-container">
				<div className="row card-details">
					<div
						className={ `form-group col-sm-6 ${ this.props.form_errors._checkout_card_name
						                                    ? 'has-error has-danger'
						                                    : '' }` }>
						<label htmlFor="checkout-card-name">Name on Card <span
							aria-hidden="true">*</span></label>
						<input
							type="text"
							name="_checkout_card_name"
							className="form-control ccard "
							id="checkout-card-name"
							required="required"
							value={ _checkout_card_name }
							onChange={ this.handleInputChange }
							onBlur={ this.validateCardName }
						/>
						<div
							className="help-block with-errors">{ this.props.form_errors._checkout_card_name }</div>
					</div>
					<div
						className={ `form-group col-sm-6 ${ this.props.form_errors._checkout_card_number
						                                    ? 'has-error has-danger'
						                                    : '' }` }>
						<label htmlFor="checkout-card-number">Card Number <span
							aria-hidden="true">*</span></label>
						<input
							type="tel"
							inputMode="numeric"
							pattern="[0-9\s]{13,19}"
							name="_checkout_card_number"
							className="form-control ccard"
							maxlength="19"
							autocomplete="cc-number"
							id="checkout-card-number"
							required="required"
							value={ _checkout_card_number }
							onChange={ this.handleInputChange }
							onBlur={ this.validateCardNumber }
						/>
						<div
							className="help-block with-errors">{ this.props.form_errors._checkout_card_number }</div>
					</div>
				</div>
				<div className="row card-details">
					<div
						className={ `form-group col-sm-3 ${ this.props.form_errors._checkout_card_expiration_month || this.props.form_errors._checkout_card_expiration
						                                    ? 'has-error has-danger'
						                                    : '' }` }>
						<label htmlFor="checkout-card-expiration-month">Expiration
							Month <span aria-hidden="true">*</span></label>
						<select
							name="_checkout_card_expiration_month"
							className="form-control ccard"
							id="checkout-card-expiration-month"
							required="required"
							value={ _checkout_card_expiration_month }
							onChange={ this.handleInputChange }
							onBlur={ this.validateExpirationMonth }
						>
							<option disabled value="">MM</option>
							{ Array.from( { length: 12 }, ( _, i ) => {
								const month = i + 1;
								const optionVal = month < 10
								                  ? `0${ month }`
								                  : `${ month }`;
								return (<option key={ optionVal }
								                value={ optionVal }>
										{ optionVal }
									</option>
								);
							} ) }
						</select>
						<div
							className="help-block with-errors">{ this.props.form_errors._checkout_card_expiration_month || this.props.form_errors._checkout_card_expiration }</div>
					</div>
					<div
						className={ `form-group col-sm-3 ${ this.props.form_errors._checkout_card_expiration_year || this.props.form_errors._checkout_card_expiration
						                                    ? 'has-error has-danger'
						                                    : '' }` }>
						<label htmlFor="checkout-card-expiration-year">Expiration
							Year <span aria-hidden="true">*</span></label>
						<select
							name="_checkout_card_expiration_year"
							className="form-control ccard"
							id="checkout-card-expiration-year"
							required="required"
							value={ _checkout_card_expiration_year }
							onChange={ this.handleInputChange }
							onBlur={ this.validateExpirationYear }
						>
							<option disabled value="">YYYY</option>
							{ Array.from( { length: 20 }, ( _, i ) => {
								const year = new Date().getFullYear() + i;
								return (<option key={ year } value={ year }>
										{ year }
									</option>
								);
							} ) }
						</select>
						<div
							className="help-block with-errors">{ this.props.form_errors._checkout_card_expiration_year || this.props.form_errors._checkout_card_expiration }</div>
					</div>
					<div
						className={ `form-group col-sm-6 ${ this.props.form_errors._checkout_card_csc
						                                    ? 'has-error has-danger'
						                                    : '' }` }>
						<label htmlFor="checkout-card-csc">Card CVV <span
							aria-hidden="true">*</span><span
							id="csc-help-text"></span></label>
						<input
							name="_checkout_card_csc"
							type="text"
							className="form-control ccard"
							id="checkout-card-csc"
							required="required"
							value={ _checkout_card_csc }
							onChange={ this.handleInputChange }
							onBlur={ this.validateCVV }
						/>
						<div>
							<small><em>3 or 4 digit number, typically printed on
								the back of your credit card.</em></small>
						</div>
						<div
							className="help-block with-errors">{ this.props.form_errors._checkout_card_csc }</div>
					</div>
				</div>
				<div className="row">
					<div
						className={ `form-group col-sm-12 ${ this.props.form_errors._checkout_card_additional_info
						                                     ? 'has-error has-danger'
						                                     : '' }` }>
						<label htmlFor="checkout-card-additional-info">Additional
							Info:</label>
						<input
							type="text"
							name="_checkout_card_additional_info"
							className="form-control"
							id="checkout-card-additional-info"
							value={ _checkout_card_additional_info }
							onChange={ this.handleInputChange }
						/>
						<div
							className="help-block with-errors">{ this.props.form_errors._checkout_card_additional_info }</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps( { form_errors } ) {
	return {
		form_errors
	};
}

export default connect( mapStateToProps, { updateFormErrors } )( CheckoutCardDetails );